import CallIcon from 'crono-fe-common/icons/Icon-Call';
import EmailIcon from 'crono-fe-common/icons/Icon-Email';
import LinkedinIcon from 'crono-fe-common/icons/Icon-Linkedin';
import MobilePhoneIcon from 'crono-fe-common/icons/Icon-Mobile-Phone';
import { ReactComponent as WebsiteIcon } from 'crono-fe-common/icons/website.svg';
import { ContactMethod, ContactMethodMeta } from './types';
import { BuildingSmIcon } from '@crono-one/design-system';

export const contactMethodMetaMap: Record<ContactMethod, ContactMethodMeta> = {
  [ContactMethod.Email]: {
    icon: <EmailIcon size={16} className="" />,
    buttonClass: 'hover:bg-red-500 hover:[&_*]:fill-white',
  },

  [ContactMethod.Phone]: {
    icon: <CallIcon size={18} className="" />,
    buttonClass: 'hover:bg-green-500 hover:[&_*]:fill-white',
  },

  [ContactMethod.MobilePhone]: {
    icon: <MobilePhoneIcon size={20} className="" />,
    buttonClass: 'hover:bg-green-500 hover:[&_*]:fill-white',
  },

  [ContactMethod.AccountPhone]: {
    icon: <BuildingSmIcon className="size-4" />,
    buttonClass: 'hover:bg-green-500 hover:[&_*]:fill-white',
  },

  [ContactMethod.Linkedin]: {
    icon: <LinkedinIcon size={16} className="" />,
    buttonClass: 'hover:bg-blue-600 hover:[&_*]:fill-white',
  },

  [ContactMethod.Website]: {
    icon: <WebsiteIcon />,
  },
};
